import React from 'react';
import InputMask from 'react-input-mask';
import Label from './Label'
import { Controller } from "react-hook-form";

export default function InputPhone(props) {

   const { id, label = "Phone", control, className = 'form-control', ...others } = props;

   return <Label label={label} id={id} {...others}>
            <Controller
               id={id} name={id} control={control}
               defaultValue=""
               render={({ field }) => ( 
                  <InputMask mask="(99)9.9999-9999" className={className} {...field} />)
               }
            />
         </Label>
}